<template>
  <v-list-item dense
               class="lighten-4 grey"
               active-class="primary"
               @click="click()"
               :value="teacher.id" id="teacher-list-item">

    <v-avatar :class="getCssClasses" v-if="allowTeacherAvatar" :size="getImgSize" color="grey">
        <v-img :src="getTeacherAvatar"/>
    </v-avatar>
    <v-list-item-content class="py-6" align="start center">
      <v-list-item-title class="body-1">{{ teacher.name }}</v-list-item-title>
      <v-list-item-subtitle v-if="teacher.shortDescription && allowTeacherShortDescription">
        {{ teacher.shortDescription }}
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="showNearestDate">
        Ближ. время: {{ getFormattedDate }}
      </v-list-item-subtitle>
      <div :id="getDescId"
           class="v-list-item-deactivate teacher-desc-container desc-text">
      </div>
      <div v-if="isSelected && btnVisibility" class="mt-3" >
          <span class="text-decoration-underline desc-text" @click="showFullDesc($event)">
            {{ showFullText }}
          </span>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'LessonTeacherListItem',
  props: ['teacher', 'selectedTeacherId', 'showNearest'],
  data: () => ({
    showFullText: 'Развернуть',
    btnVisibility: false,
  }),
  watch: {
    isSelected() {
      if (!this.isSelected) {
        const elem = document.getElementById(this.getDescId);
        if (elem) elem.innerHTML = '';
      }
    },
  },
  computed: {
    getDescId() {
      return `${this.teacher.id}FullDesc`;
    },
    showNearestDate() {
      return (typeof this.showNearest === 'undefined') ? true : this.showNearest;
    },
    getTeacherAvatar() {
      return (this.teacher.avatar) ? this.teacher.avatar.link : null;
    },
    allowTeacherAvatar() {
      return this.UISettings.joinIndividualParams.showTeachersAvatars;
    },
    getCssClasses() {
      return (this.isSelected)
        ? ((this.teacher.description) ? 'mr-3 mt-6 teacher-avatar' : 'mr-3') : 'mr-3';
    },
    getFormattedDate() {
      const days = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];
      const [firstFree] = this.teacher.freeTime;
      let str = '';
      if (firstFree && firstFree.date && firstFree.time) {
        const date = new Date(firstFree.date);
        str = `${days[date.getDay()]}, ${moment(date).format('DD.MM')} ${firstFree.time} `;
      }

      return str;
    },
    allowTeacherDescription() {
      return this.UISettings.joinIndividualParams.showTeachersDescription;
    },
    allowTeacherShortDescription() {
      return this.UISettings.joinIndividualParams.showTeachersShortDescription;
    },
    getImgSize() {
      return (this.selectedTeacherId === this.teacher.id) ? 70 : 50;
    },
    isSelected() {
      return this.selectedTeacherId === this.teacher.id;
    },
    ...mapGetters(['UISettings']),
  },
  methods: {
    showFullDesc(event) {
      const elem = document.getElementById(this.getDescId);
      event.stopPropagation();
      switch (this.showFullText) {
        case 'Развернуть':
          this.showFullText = 'Свернуть';
          if (elem) elem.classList.remove('teacher-desc-min');
          break;
        case 'Свернуть':
          this.showFullText = 'Развернуть';
          if (elem) elem.classList.add('teacher-desc-min');
          break;
        default:
          break;
      }
    },
    click() {
      const elem = document.getElementById(this.getDescId);
      if (this.allowTeacherDescription && this.teacher.description && !this.isSelected) {
        elem.innerHTML = this.teacher.description;
        elem.classList.add('mt-2');
        if (elem && elem.offsetHeight > 65) {
          elem.classList.add('teacher-desc-min');
          this.btnVisibility = true;
        }
      } else {
        elem.innerHTML = '';
        this.showFullText = 'Развернуть';
      }
    },
  },
};
</script>

<style scoped>
#teacher-list-item {
  min-height: 80px;
}

.teacher-desc-min {
  max-height: 50px;
  overflow: hidden;
}

.teacher-desc-container iframe {
  width: 100%;
}

.v-list-item-deactivate {
  white-space: initial;
}

.teacher-desc-container img {
  width: 100%;
}

.teacher-avatar {
  align-self: baseline;
}

.desc-text {
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1rem;
  color: rgba(0, 0, 0, 0.6);
}

</style>
